import { Component } from 'react';
import Slider from 'react-slick';
import { SubHeading } from '../common/subHeading';
class Testimonial extends Component<any, any> {
  public componentDidMount() {
    // new Foundation.Equalizer($("#equalizer_testimonial"));
  }

  public render() {
    const { SECTION_TESTIMONIALS } = this.props;
    const testimonials = [];

    for (let idx = 0; idx < SECTION_TESTIMONIALS.length; idx++) {
      testimonials.push(
        <div
          className="small-12 medium-4 large-4 columns CT-testimonial-content-wrap"
          key={'test_' + idx}
        >
          <div
            className="testimonial-container"
            data-equalizer-watch="testimonials"
          >
            <div className="text">
              <p className="lil-text-base sm:lil-text-s-14">
                {SECTION_TESTIMONIALS[idx].text}
              </p>
            </div>
            <div className="lil-flex lil-mt-10">
              <div className="lil-mr-2">
                <img
                  src={SECTION_TESTIMONIALS[idx].image}
                  className="author-img"
                />
              </div>
              <div className="author">
                <p className="author-name lil-font-semibold lil-m-0 lil-text-font-500">
                  {SECTION_TESTIMONIALS[idx].author}
                </p>
                <p className="author-place lil-text-font-200 lil-text-s-14">
                  {SECTION_TESTIMONIALS[idx].place}
                </p>
              </div>
            </div>
          </div>
        </div>
      );
    }

    const settings = {
      dots: false,
      infinite: true,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 1,
      speed: 500,
      adaptiveHeight: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            initialSlide: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
    };

    return (
      <div className="lil-mt-20">
        <div className="lil-pr-12 sm:lil-overflow-auto sm:lil-pr-0">
          <div className="lil-mb-6">
            <SubHeading title="See what our clients have to say" />
          </div>
          <div className="row expanded CT-homepage-new-testimonials section-wrap fontGilroy">
            <div
              className="row CT-testimonial-content"
              data-equalizer="testimonials"
              id="equalizer_testimonial"
            >
              <Slider {...settings}>{testimonials}</Slider>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Testimonial;



// WEBPACK FOOTER //
// ./components/homePageNew/testimonial.tsx